<!---------------------------------------
                FEATURED TOURNAMENTS
----------------------------------------->
<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="01">
        <ng-container *ngTemplateOutlet="tournamentsNewDefault"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="02">
        <!-- NOTA: TROCA RECENTE POR NOVO TEMPLATE COM FILTROS POR DEPARTAMENTOS -->
        <ng-container *ngTemplateOutlet="tournamentsDepartmentFilter"></ng-container>
    </ng-container>
</ng-container>

<!------------- TYPE 1: Grouped by Tabs ----------------->
<ng-template #tournamentsNewDefault>
    <div *ngIf="registers">
        <div class="row justify-content-between align-items-center"></div>
        <nb-tabset>
            <h3 class="heading" ngProjectAs="nb-tab">{{ "HOME.TOURNAMENT-HIGHLIGHTS" | translate }}</h3>
            <nb-tab
                *ngFor="let tournamentGroup of registers; let index = index"
                [tabTitle]="tournamentGroup.descricao"
                [active]="index === 0"
            >
                <div class="row tournaments-row">
                    <div class="col-lg-4" *ngFor="let tournament of tournamentGroup.list">
                        <a
                            [routerLink]="['/' + tournament.route + '/tournament', tournament.id_torneio]"
                            class="tournament"
                        >
                            <nb-card accent="primary">
                                <nb-card-body>
                                    <nb-tag-list class="mb-2">
                                        <nb-tag
                                            [status]="
                                                tournament.situacao === '3'
                                                    ? 'success'
                                                    : tournament.situacao === '5'
                                                    ? 'info'
                                                    : 'basic'
                                            "
                                            [text]="tournament.descricao_situacao"
                                            appearance="outline"
                                        ></nb-tag>
                                    </nb-tag-list>
                                    <span class="tournament-name">{{ tournament.nome_torneio }}</span>

                                    <div class="tournament-info">
                                        <div class="mr-md-4">
                                            <p>
                                                <nb-icon icon="calendar-outline"></nb-icon>
                                                {{ tournament.dt_inicio }} {{ "GENERAL.UNTIL" | translate }}
                                                {{ tournament.dt_final }}
                                            </p>
                                        </div>
                                        <div class="mr-md-4">
                                            <p>
                                                <nb-icon icon="pin-outline"></nb-icon>
                                                {{ tournament.cidade }} /
                                                {{ tournament.uf }}
                                            </p>
                                        </div>
                                    </div>
                                </nb-card-body>
                            </nb-card>
                        </a>
                    </div>
                    <nb-card class="no-results" *ngIf="!tournamentGroup.list?.length">
                        <nb-card-body>
                            <svg
                                width="84px"
                                height="84px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14.5776 14.5419C15.5805 13.53 16.2 12.1373 16.2 10.6C16.2 7.50721 13.6928 5 10.6 5C7.50721 5 5 7.50721 5 10.6C5 13.6928 7.50721 16.2 10.6 16.2C12.1555 16.2 13.5628 15.5658 14.5776 14.5419ZM14.5776 14.5419L19 19M8.5 8.5L12.5 12.5M12.5 8.5L8.5 12.5"
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            <p class="paragraph-1">{{ "RESULT.NO-RESULTS" | translate }}</p>
                        </nb-card-body>
                    </nb-card>
                </div>
            </nb-tab>
        </nb-tabset>
    </div>
</ng-template>

<!------------- TYPE 2: Slide with filters ----------------->
<ng-template #tournamentsInline>
    <div class="featured-tournaments featured-tournaments--inline" *ngIf="registers">
        <div class="row">
            <div class="col-auto">
                <h3 class="heading">{{ "HOME.TOURNAMENT-HIGHLIGHTS" | translate }}</h3>
            </div>
            <div class="col-auto align-self-center pl-0">
                <nb-checkbox
                    *ngFor="let filter of filters; let index = index"
                    [checked]="filter.checked"
                    (checkedChange)="onSituationChange($event, filter.value, index)"
                    class="mr-3"
                >
                    {{ "TOURNAMENT.SITUATION." + filter.value | translate }}
                </nb-checkbox>
            </div>
            <div class="col-12">
                <ngx-glide
                    *ngIf="registers && registers.length"
                    [perView]="(homeService.hasEvents | async) ? 2 : 3"
                    [showBullets]="false"
                    [arrowLeftTemplate]="arrowLeft"
                    [arrowRightTemplate]="arrowRight"
                    [breakpoints]="breakpoints"
                    #ngxGlide
                >
                    <app-card-featured
                        *ngFor="let tournament of registers; let index = index"
                        [routerLink]="['/' + tournament.route + '/tournament', tournament.id_torneio]"
                        [title]="tournament.nome_torneio"
                        [accent]="
                            tournament.situacao === '3' ? 'success' : tournament.situacao === '5' ? 'info' : 'basic'
                        "
                        [location]="tournament.cidade + ' / ' + tournament.uf"
                        [date]="
                            tournament.dt_inicio + ' ' + translate.instant('GENERAL.UNTIL') + ' ' + tournament.dt_final
                        "
                        [tag]="tournament.descricao_situacao"
                        [entityAvatar]="tournament.url_avatar"
                        [entity]="translate.instant('GENERAL.CREATED-BY') + ' ' + tournament.por"
                        [department]="tournament.nome_depto"
                    >
                    </app-card-featured>
                </ngx-glide>
                <nb-card class="no-results" *ngIf="!registers.length">
                    <nb-card-body>
                        <svg
                            width="84px"
                            height="84px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M14.5776 14.5419C15.5805 13.53 16.2 12.1373 16.2 10.6C16.2 7.50721 13.6928 5 10.6 5C7.50721 5 5 7.50721 5 10.6C5 13.6928 7.50721 16.2 10.6 16.2C12.1555 16.2 13.5628 15.5658 14.5776 14.5419ZM14.5776 14.5419L19 19M8.5 8.5L12.5 12.5M12.5 8.5L8.5 12.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <p class="paragraph-1">{{ "RESULT.NO-RESULTS" | translate }}</p>
                    </nb-card-body>
                </nb-card>
            </div>
            <ng-template #arrowLeft>
                <button nbButton><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
            </ng-template>
            <ng-template #arrowRight>
                <button nbButton><nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
            </ng-template>
        </div>
    </div>
</ng-template>
<!------------- TYPE 3: Slide with Department filter ----------------->
<ng-template #tournamentsDepartmentFilter>
    <div class="featured-tournaments featured-tournaments--inline featured-tournaments--department">
        <div class="row">
            <div class="col-auto">
                <h3 class="heading">{{ "HOME.TOURNAMENT-HIGHLIGHTS" | translate }}</h3>
            </div>
            <div class="col-auto align-self-center mb-3 mb-md-0">
                <nb-select
                    placeholder="Departamentos"
                    [(ngModel)]="selectedDepartment"
                    (selectedChange)="onDepartmentChange($event)"
                >
                    <nb-option *ngFor="let option of departmentFilters" [value]="option.tipo_depto">
                        {{ option.descricao }}
                    </nb-option>
                </nb-select>
            </div>
            <div class="col-auto align-self-center ml-auto">
                <button nbButton status="primary" outline size="small" [routerLink]="['/tournaments/all']">
                    {{ "GENERAL.SEE-ALL" | translate }}
                </button>
            </div>
            <div class="col-12" [nbSpinner]="loading" *ngIf="registers">
                <ngx-glide
                    *ngIf="registers && registers.length"
                    [perView]="(homeService.hasEvents | async) ? 2 : 3"
                    [showBullets]="false"
                    [arrowLeftTemplate]="arrowLeft"
                    [arrowRightTemplate]="arrowRight"
                    [breakpoints]="breakpoints"
                    #ngxGlide
                >
                    <app-card-featured
                        *ngFor="let tournament of registers; let index = index"
                        [routerLink]="['/' + tournament.route + '/tournament', tournament.id_torneio]"
                        [title]="tournament.nome_torneio"
                        [accent]="
                            tournament.situacao === '3' ? 'success' : tournament.situacao === '5' ? 'info' : 'basic'
                        "
                        [location]="tournament.cidade + ' / ' + tournament.uf"
                        [date]="
                            tournament.dt_inicio + ' ' + translate.instant('GENERAL.UNTIL') + ' ' + tournament.dt_final
                        "
                        [tag]="tournament.descricao_situacao"
                        [entityAvatar]="tournament.url_avatar"
                        [entity]="translate.instant('GENERAL.CREATED-BY') + ' ' + tournament.por"
                        [department]="tournament.nome_depto"
                    >
                    </app-card-featured>
                </ngx-glide>
            </div>
            <div class="col-12" *ngIf="!registers && statusCode > 0">
                <nb-card class="no-results">
                    <nb-card-body>
                        <svg
                            width="84px"
                            height="84px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M14.5776 14.5419C15.5805 13.53 16.2 12.1373 16.2 10.6C16.2 7.50721 13.6928 5 10.6 5C7.50721 5 5 7.50721 5 10.6C5 13.6928 7.50721 16.2 10.6 16.2C12.1555 16.2 13.5628 15.5658 14.5776 14.5419ZM14.5776 14.5419L19 19M8.5 8.5L12.5 12.5M12.5 8.5L8.5 12.5"
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <p class="paragraph-1">{{ "MESSAGE.RESULT.NO-RESULTS" | translate }}</p>
                    </nb-card-body>
                </nb-card>
            </div>
            <ng-template #arrowLeft>
                <button nbButton size="small"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
            </ng-template>
            <ng-template #arrowRight>
                <button nbButton size="small"><nb-icon icon="arrow-ios-forward-outline"></nb-icon></button>
            </ng-template>
        </div>
    </div>
</ng-template>
